import {
  Box,
  FormControl,
  InputLabel,
  Input,
  Button,
  Alert,
  Select,
  MenuItem,
  TextField,
  FormHelperText,
} from "@mui/material";
import { useState, useEffect } from "react";
//import usePostData from "../../../utility/usePostData";
import axios from "axios";
import useFetchData from "../../../utility/useFecthData";
import { useHistory, useParams } from "react-router-dom";

const FormAddInstution = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [mobile, setMobile] = useState("XX");
  const [description, setDescription] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState([]);
  const [fieldErrors, setFieldErrors] = useState({});
  let { data: roles } = useFetchData("roles");
  const [roleId, setRoleId] = useState("");
  let { id: institution_id } = useParams();
  const [errorMessages, setErrorMessages] = useState(null);

  useEffect(() => {
    if (error && error.errors) {
      setErrorMessages(Object.entries(error.errors));
    }
  }, [error]);

  const submitData = async (e) => {
    e.preventDefault();

    // Client-side validation
    const errors = {};
    if (!name) errors.name = "Le nom est requis";
    if (!email) errors.email = "L'email est requis";
    else {
      const emailRe = /^\S+@\S+\.\S+$/;
      if (!emailRe.test(email)) errors.email = "Email invalide";
    }
    if (!password) errors.password = "Le mot de passe est requis";
    else if (password.length < 6)
      errors.password = "Le mot de passe doit contenir au moins 6 caractères";
    if (!roleId) errors.roleId = "Le rôle est requis";
    if (telephone) {
      const phoneRe = /^[0-9()+\-\s]+$/;
      if (!phoneRe.test(telephone))
        errors.telephone = "Numéro de téléphone invalide";
    }

    setFieldErrors(errors);
    if (Object.keys(errors).length > 0) {
      setError("Veuillez corriger les champs requis.");
      return;
    }

    setIsLoading(true);
    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        "users",
        {
          name,
          email,
          password,
          role_id: roleId,
          telephone,
          description,
          mobile,
          institution_id,
        },
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        },
      );
      setIsLoading(false);
      window.location.reload();
      console.log(response.data);
    } catch (err) {
      // Map server validation errors to field errors if present
      if (err.response?.data?.error) {
        const srv = err.response.data.error;
        const mapped = {};
        Object.keys(srv).forEach((k) => {
          if (Array.isArray(srv[k])) mapped[k] = srv[k][0];
          else mapped[k] = srv[k];
        });
        setFieldErrors(mapped);
        setError(mapped.message || "Erreurs de validation");
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError("Une erreur est survenue");
      }
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "80%",
        margin: "auto",
      }}
    >
      <div>
        <h5>Ajouter un utilisateur</h5>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard" size="small">
          <InputLabel htmlFor="name">Nom et Prénom *</InputLabel>
          <Input
            id="name"
            value={name}
            required
            onChange={(e) => setName(e.target.value)}
          />
          {fieldErrors.name && (
            <FormHelperText error>{fieldErrors.name}</FormHelperText>
          )}
        </FormControl>
        <FormControl fullWidth sx={{ m: 1 }} variant="standard" size="small">
          <InputLabel htmlFor="email">Email *</InputLabel>
          <Input
            id="email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {fieldErrors.email && (
            <FormHelperText error>{fieldErrors.email}</FormHelperText>
          )}
        </FormControl>

        <FormControl fullWidth sx={{ m: 1 }} variant="standard" size="small">
          <InputLabel htmlFor="telephone">Téléphone</InputLabel>
          <Input
            id="telephone"
            type="text"
            required
            value={telephone}
            onChange={(e) => setTelephone(e.target.value)}
          />
          {fieldErrors.telephone && (
            <FormHelperText error>{fieldErrors.telephone}</FormHelperText>
          )}
        </FormControl>
        <FormControl fullWidth size="small">
          <InputLabel id="role_id">Role</InputLabel>
          <Select
            labelId="role_id"
            id="role_id"
            value={roleId}
            label="Age"
            onChange={(e) => setRoleId(e.target.value)}
          >
            {roles &&
              roles?.data?.map(
                (role, index) =>
                  role.name === "EMPLOYEUR" && (
                    <MenuItem key={index} value={role?.id}>
                      {role?.name}
                    </MenuItem>
                  ),
              )}
          </Select>
          {fieldErrors.roleId && (
            <FormHelperText error>{fieldErrors.roleId}</FormHelperText>
          )}
        </FormControl>

        <FormControl fullWidth sx={{ m: 1 }} variant="standard" size="small">
          <InputLabel htmlFor="password">Mot de passe *</InputLabel>
          <Input
            id="password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          {fieldErrors.password && (
            <FormHelperText error>{fieldErrors.password}</FormHelperText>
          )}
        </FormControl>

        <FormControl fullWidth sx={{ m: 1 }} variant="standard" size="small">
          <TextField
            id="description"
            label="Multiline"
            multiline
            rows={4}
            defaultValue="Default Value"
            onChange={(e) => setDescription(e.target.value)}
          />
        </FormControl>
        <Button
          variant="contained"
          type="submit"
          onClick={submitData}
          disabled={isLoading}
        >
          Enregistrer
        </Button>
        {isLoading && <div>Is Loading...</div>}
        {error && (
          <Box sx={{ mt: 2 }}>
            <Alert severity="error">{error}</Alert>
          </Box>
        )}
      </div>
    </Box>
  );
};

export default FormAddInstution;
